//#region types
import { InvoicePeriodSectionProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { GroupSectionInline } from "components/common/wintForms";
import ContentDialog from "components/common/dialogs/_contentDialog";
import DialogEvents from "components/common/dialogs/dialogEvents";
import PeriodisationSummary from "../_fields/periodisationSummary";
import useEditPeriodisationDialog from "../useEditPeriodisationDialog";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const isEditablePeriodisationStatus = (status?: WintSuperkollAPIModel.InvoiceStatus) =>
  status !== undefined &&
  status !== WintSuperkollAPIModel.InvoiceStatus.NotSent &&
  status !== WintSuperkollAPIModel.InvoiceStatus.Cancelled;

const InvoicePeriodSection: React.FC<InvoicePeriodSectionProps> = (props) => {
  const { invoice, values, isRecurring, loadInvoice, fileViewer } = props;

  const sentInvoice = !isRecurring ? (invoice as WintSuperkollAPIModel.Invoice) : undefined;
  const canEdit = isEditablePeriodisationStatus(sentInvoice?.status);
  const hasPeriodisation = !!invoice.rows?.some((row) => row.periodisation);
  const hidden = isRecurring || (!canEdit && !hasPeriodisation);

  const getDialog = useEditPeriodisationDialog(
    sentInvoice ?? ({} as WintSuperkollAPIModel.Invoice),
    loadInvoice,
    fileViewer
  );

  const editButtonLabel = !hasPeriodisation
    ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Add)
    : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Edit);

  return !hidden ? (
    <GroupSectionInline
      key={`invoice-section-periods`}
      label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Accrual)}
      icon={IconDefinitionConstants.WMonthCalendar}
    >
      <DialogEvents
        render={(isOpen, openDialog, closeDialog, key) => (
          <>
            <Grid container className={clsx(cssExports.readOnlyForm, cssExports.groupSectionInlineDetailsTable)}>
              <PeriodisationSummary
                value={values.periodisationSummary ?? []}
                showHeaders
                onEditClick={canEdit ? openDialog : undefined}
                editButtonLabel={editButtonLabel}
              />
            </Grid>
            {canEdit && <ContentDialog key={key} {...getDialog()} isOpen={isOpen} closeDialog={closeDialog} />}
          </>
        )}
      />
    </GroupSectionInline>
  ) : (
    <></>
  );
};

export default InvoicePeriodSection;
